<!--
***********************
***** PLEASE READ *****
***********************
This component contains two sections with the first being for the Digital/web version.
The second is for the print PDF version.
If any generic amends are made, please check and ensure they are made to both sections if required.
-->
@if (!isPrintPDFRoute) {
  <section class="section hide-for-pdf-print">
    <div class="container value-statement">
      <h2 class="secondary-heading" [innerText]="'We value you.' | translate"></h2>
      @if (speaker && speakerRole) {
        <h3 class="tertiary-heading"
        >{{'A special message from' | translate}} {{speakerRole}} {{speaker}}.</h3>
      }
      <div class="print-only">
        <p class="text-center" [innerText]="videoUrlForPrint"></p>
      </div>
      @if (isVideoRequired) {
        <div class="video-wrapper">
          <div class="video-inline ratio_16-9 video">
            <iframe
              id="video-player-{{videoId}}"
              title="A special message"
              [src]="videoUrl">
            </iframe>
          </div>
        </div>
      }
      @if (!isVideoRequired) {
        <div class="value-statement-no-video">
          <div class="value-statement-no-video__image">
            <img [src]="image" alt="Profile Image">
          </div>
          <p class="value-statement-no-video__text" [innerHTML]="text"></p>
        </div>
      }
    </div>
  </section>
}

@if (isPrintPDFRoute) {
  <section class="section pdf-page-wrapper">
    <div class="container value-statement">
      <div class="value-statement-inner-wrapper">
        <div class="value-statement-inner-left">
          <img [src]="image" class="value-statement-image" alt="Profile Image">
          @if (speaker) {
            <h3 [innerText]="speaker"></h3>
          }
          @if (speakerRole) {
            <h3 [innerText]="speakerRole"></h3>
          }
        </div>
        <div class="value-statement-inner-right">
          <h2 class="secondary-heading" [innerText]="'We value you.' | translate"></h2>
          <div [innerHTML]="text"></div>
        </div>
      </div>
    </div>
  </section>
}
